<template>
  <EditDialog
    ref="addDialog"
    :errors="errors"
    :confirm-cancel="onCancelDialog"
    mode="add"
    @close="onClose"
    @save="saveItem"
    @reset="resetItem"
    @open-prefills="openPrefill"
  />

  <BatchPrefillDialog
    ref="batchPrefillDialog"
    @create-new="open({}, false)"
  />
</template>

<script>
import CreateSelectionPluginDialog from 'components/app/inventory/partials/CreateSelectionPluginDialog.vue'
import BatchPrefillDialog from 'components/app/inventory/defaults/BatchPrefillDialog.vue'
import EditDialog from './partials/EditDialog'

import { parseForSubmission } from 'components/partials/metadata/metadataMixin'
import { store } from 'src/store'
import { Dialog } from 'quasar'

function newItem (payload = {}) {
  const companyDetails = store.getters['company/getCompany']
  return {
    code: payload.code || null,
    type: payload.type || 'SERVICE',
    system_type_id: null,
    name: payload.name || null,
    description: payload.description || null,
    metadata: [],
    is_buying: false,
    is_selling: true,
    selling_unit_price: payload.selling_unit_price || 0,
    selling_tax_type: payload.selling_tax_type || companyDetails.inventory_tax_type,
    is_tracked: false,
    prefill_column: store.getters['company/getCompany'].inventory_prefill_column,
    markup_percentage: 0
  }
}

export default {
  components: {
    BatchPrefillDialog,
    EditDialog
  },
  emits: ['created'],
  data () {
    return {
      errors: {}
    }
  },
  methods: {
    openPrefill () {
      this.$refs.batchPrefillDialog.open()
    },
    open (payload = null, showPopup = false) {
      const doCreate = () => this.$refs.addDialog.open(newItem(payload || {}))

      if (!showPopup || !this.company.industry_settings.setup_prefill_inventory || this.$store.getters.getNewbie.includes(this.newbies.setupDismissPrefillInventory)) {
        doCreate()
      }
      else {
        Dialog.create({
          component: CreateSelectionPluginDialog
        })
          .onOk((selection) => {
            switch (selection) {
              case 'prefill':
                this.openPrefill()
                break
              case 'create':
                doCreate()
                break
            }
          })
      }
    },
    onClose () {
      this.errors = {}
    },
    onCancelDialog (callback) {
      this.$q.dialog({
        title: 'Confirm',
        message: [
          'Are you sure you want to back?',
          'This inventory item will not be saved and any changes will be lost.'
        ],
        ok: true,
        cancel: true,
        color: 'orange-7'
      })
        .onOk(callback)
    },
    resetItem () {
      this.$refs.addDialog.close()
      this.$nextTick(() => {
        this.open()
      })
    },
    async saveItem (item) {
      this.$loading.show()
      this.errors = {}
      const { status, payload, errors } = await this.$post('v1/inventory', {
        ...item,
        metadata: parseForSubmission(item.metadata)
      })
      this.$loading.hide()
      if (status === 'success') {
        this.$q.notify({
          color: 'green',
          message: 'Item successfully created.'
        })
        this.$refs.addDialog.close()
        this.$emit('created', payload)
      }
      else {
        this.errors = errors
        this.$nextTick(() => { this.scrollToFirstError(this.$el) })
      }
    }
  }
}
</script>
